import { Box, useTheme } from '@mui/material';
import React, { useState } from 'react';
import ResultTabHeader, {
  ResultTabValue,
} from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-result-tab/result-tab-header';
import Divider from 'components/divider';
import ScenarioResultSites from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-result-tab/result-sites/scenario-result-sites';
import ScenarioFishGroupList from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-result-tab/fish-groups/scenario-fish-group-list';

const ScenarioResultTab = () => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState<ResultTabValue>('left');

  return (
    <Box flexDirection="column" display="flex" gap={6}>
      <ResultTabHeader selectedTab={selectedTab} onTabChange={setSelectedTab} />
      <Divider dark />
      {selectedTab === 'left' && <ScenarioResultSites />}
      {selectedTab === 'right' && <ScenarioFishGroupList />}
    </Box>
  );
};

export default React.memo(ScenarioResultTab);
